import React, { useContext, useState } from 'react';
import { ProductContext } from '../context/ProductContext';

const MAX_PRICE = 3000;

const SORT_OPTIONS = [
  { value: '', label: 'Relevance' },
  { value: 'price-asc', label: 'Price: Low to High' },
  { value: 'price-desc', label: 'Price: High to Low' },
  { value: 'rating-desc', label: 'Rating: High to Low' },
];

const Filter = () => {
  const { categories, filters, setFilters, resetFilters } = useContext(ProductContext);
  const [range, setRange] = useState([filters.minPrice ?? 0, filters.maxPrice ?? MAX_PRICE]);
  const [priceOpen, setPriceOpen] = useState(true);
  const [categoryOpen, setCategoryOpen] = useState(true);

  const handleMinChange = (e) => {
    const value = Math.min(Number(e.target.value), range[1] - 10);
    setRange([value, range[1]]);
  };

  const handleMaxChange = (e) => {
    const value = Math.max(Number(e.target.value), range[0] + 10);
    setRange([range[0], value]);
  };

  const applyPriceFilter = () => {
    setFilters({ minPrice: range[0], maxPrice: range[1] });
  };

  const applyCategory = (category) => {
    setFilters({ category, search: '' });
  };

  const applySort = (e) => {
    const [sortBy, order] = e.target.value ? e.target.value.split('-') : ['', 'asc'];
    setFilters({ sortBy, order });
  };

  const sortValue = filters.sortBy ? `${filters.sortBy}-${filters.order}` : '';
  const hasActiveFilters = filters.category || filters.minPrice != null || filters.sortBy || filters.search;

  return (
    <div className="space-y-6">
      <div>
        <label className="mb-1 block text-sm font-semibold text-gray-700">Sort by</label>
        <select
          value={sortValue}
          onChange={applySort}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
        >
          {SORT_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>

      <div className="border-t border-gray-100 pt-4">
        <button
          className="flex w-full items-center justify-between text-sm font-semibold text-gray-700"
          onClick={() => setPriceOpen(!priceOpen)}
        >
          Price Range
          <span className="text-gray-400">{priceOpen ? '▾' : '▸'}</span>
        </button>

        {priceOpen && (
          <div className="mt-3 space-y-3">
            <div className="flex justify-between text-xs text-gray-500">
              <span>${range[0]}</span>
              <span>${range[1]}</span>
            </div>
            <div className="relative h-6">
              <div className="absolute top-1/2 h-1 w-full -translate-y-1/2 rounded-full bg-gray-200" />
              <div
                className="absolute top-1/2 h-1 -translate-y-1/2 rounded-full bg-brand-600"
                style={{
                  left: `${(range[0] / MAX_PRICE) * 100}%`,
                  right: `${100 - (range[1] / MAX_PRICE) * 100}%`,
                }}
              />
              <input
                type="range"
                min={0}
                max={MAX_PRICE}
                step={10}
                value={range[0]}
                onChange={handleMinChange}
                className="range-slider"
              />
              <input
                type="range"
                min={0}
                max={MAX_PRICE}
                step={10}
                value={range[1]}
                onChange={handleMaxChange}
                className="range-slider"
              />
            </div>
            <button
              onClick={applyPriceFilter}
              className="w-full rounded-lg bg-brand-600 py-1.5 text-sm font-medium text-white hover:bg-brand-700"
            >
              Apply
            </button>
          </div>
        )}
      </div>

      <div className="border-t border-gray-100 pt-4">
        <button
          className="flex w-full items-center justify-between text-sm font-semibold text-gray-700"
          onClick={() => setCategoryOpen(!categoryOpen)}
        >
          Category
          <span className="text-gray-400">{categoryOpen ? '▾' : '▸'}</span>
        </button>

        {categoryOpen && (
          <div className="mt-3 flex flex-wrap gap-2">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => applyCategory(category)}
                className={`rounded-full border px-3 py-1 text-xs font-medium capitalize transition ${
                  filters.category === category
                    ? 'border-brand-600 bg-brand-50 text-brand-700'
                    : 'border-gray-200 text-gray-600 hover:bg-gray-50'
                }`}
              >
                {category.replace(/-/g, ' ')}
              </button>
            ))}
          </div>
        )}
      </div>

      {hasActiveFilters && (
        <button
          onClick={() => {
            resetFilters();
            setRange([0, MAX_PRICE]);
          }}
          className="w-full rounded-lg border border-gray-300 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50"
        >
          Clear filters
        </button>
      )}
    </div>
  );
};

export default Filter;
